import firedux from '../firedux'

import {
  CONVERSATIONS_PRIVATE_REFS_ENDPOINT,
  MESSAGE_TYPES
} from '../../config/constants'

const getMessageTime = (messageRef) => {
  return messageRef.child('time').once('value')
    .then((snapshot) => snapshot.val())
}

const updateLatestMessageTimeForUser = (uid, otherUid, latestMessageTime) => {
  if (!uid || !otherUid || !latestMessageTime) return latestMessageTime

  const ref = firedux.ref.child(CONVERSATIONS_PRIVATE_REFS_ENDPOINT).child(uid).child(otherUid).child('latestMessageTime')

  return ref.set(latestMessageTime)
    .then(() => latestMessageTime)
}

export default (type, from, to, ref) => {
  if (!type || !from || !to || !ref) return ref
  if (type !== MESSAGE_TYPES.NORMAL) return ref

  return getMessageTime(ref)
    .then(updateLatestMessageTimeForUser.bind(null, from, to))
    .then(updateLatestMessageTimeForUser.bind(null, to, from))
    .then(() => ref)
}



/** WEBPACK FOOTER **
 ** ./modules/shared/data/setters/update_latest_message_times.js
 **/